import { $isLinkNode, LinkNode } from '@lexical/link';
import { RangeSelection } from 'lexical';

/**
 * Checks if a URL value is a variable token (e.g., [$PAYMENT_LINK_URL$])
 * Variable tokens should not have URL scheme normalization applied.
 */
export const isVariableToken = (value: string): boolean => {
  return /^\[\$[^$]*\$\]$/.test(value);
};

/**
 * Normalizes a URL by adding https:// scheme if not present.
 * Skips normalization for variable tokens.
 */
export const normalizeUrlScheme = (value: string): string => {
  // Don't normalize variable tokens - they will be resolved at send-time
  if (isVariableToken(value)) {
    return value;
  }
  return value.startsWith('http://') || value.startsWith('https://')
    ? value
    : `https://${value}`;
};

export const getLinkNodeFromSelection = (selection: RangeSelection) => {
  const node = selection.anchor.getNode();
  const parent = node?.getParent();
  if ($isLinkNode(node) || $isLinkNode(parent)) {
    return $isLinkNode(node) ? node : (parent as LinkNode);
  }

  return null;
};
